import { fabric } from 'fabric';

export interface TextStyle {
  name: string;
  text: string;
  options: fabric.ITextOptions;
  // Font size of the sample in the Text panel.
  previewSize: number;
}

// Only fonts and weights that public/index.html loads, so players draw the
// same text (most fonts there have regular and bold only).
export const textStyles: TextStyle[] = [
  {
    name: 'Bold headline',
    text: 'Bold headline',
    options: { fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: 140 },
    previewSize: 20,
  },
  {
    name: 'Elegant title',
    text: 'Elegant title',
    options: {
      fontFamily: 'Playfair Display',
      fontWeight: 'bold',
      fontSize: 130,
    },
    previewSize: 22,
  },
  {
    name: 'Condensed capitals',
    text: 'OPEN TODAY',
    options: { fontFamily: 'Bebas Neue', fontSize: 200, charSpacing: 100 },
    previewSize: 26,
  },
  {
    name: 'Poster',
    text: 'BIG SALE',
    options: { fontFamily: 'Anton', fontSize: 180 },
    previewSize: 24,
  },
  {
    name: 'Script',
    text: 'Welcome',
    options: { fontFamily: 'Great Vibes', fontSize: 160 },
    previewSize: 30,
  },
  {
    name: 'Caption label',
    text: 'CAPTION LABEL',
    options: { fontFamily: 'Roboto Mono', fontSize: 40, charSpacing: 200 },
    previewSize: 12,
  },
];
